module.exports = __webpack_public_path__ + "static/chaspy_-07f3167dff29dd0ae6a4aa2d9f219105.jpg";